import initializeNewUserAssessment from "../initializeNewUserAssessment"
import { 
  makeBackupUsername, 
  addActivities,
  addScoring,
  zeroTimeRemaining,
  addAnswersByItem,
} from "./"
import { db } from "../../../config/firebaseconfig"

/**
 * Generates a userAssessment given csv upload data.
 * @param {object} record one row of student data parsed from the csv
 * @param {object} school The school object
 * @param {string} schoolYear The active school year ('2018' for 2018-19, for example)
 * @param {string} assessmentId The id of the assessment we are uploading data about
 * @param {object} sets content sets from the database. 
 * @param {object} items contentItems from the database.
 * @param {function} updateState this.setState bound to UploadCSVContainer
 * @returns {string} id of the userAssessment generated
 */
export default function createUserAssessment (record, school, schoolYear, assessmentId, sets, items, updateState) {
  let withAnswersByItem
  
  // get the student user data
  // look up by email, or username, or backup username
  let studentIdentifier, lookup, userAssessmentId
  if (record.email) {
    studentIdentifier = record.email
    lookup = 'email'
  } else if (record.username) {
    studentIdentifier = record.username
    lookup = 'username'
  } else {
    studentIdentifier = makeBackupUsername(record)
    lookup = 'username'
  }
  
  return db.collection('students').where(lookup, '==', studentIdentifier).get()
    .then(querySnapshot => {
      // use the querySnapshot to get the studentUser object
      let studentUser
      querySnapshot.forEach(doc => {
        if (!doc.exists) return
        const stu = doc.data()
        if (stu.school === school.id) {
          studentUser = stu
        }
      })
      // if can't find the student user, don't do anything
      if (!studentUser) return null  

      const newUserAssessment = Object.values(initializeNewUserAssessment(assessmentId, sets, items, studentUser.id, studentUser))[0]
      // add all activities to the userAssessment
      const withActivities = addActivities(newUserAssessment, record, studentUser.id, items)
      // compute and add scoring information
      const withScoring = addScoring(withActivities)
      // add timeRemaining: 1 to destructured subtests (test to see if we can eliminate this)
      const withTimeRemainingZero = zeroTimeRemaining(withScoring)
      // compute and add answersByItem information
      withAnswersByItem = addAnswersByItem(withTimeRemainingZero)

      // update the user with info on the new assessment
      const batch = db.batch()
      userAssessmentId = withAnswersByItem.userAssessmentId
      const studentRef = db.collection('students').doc(studentUser.id)
            
      const assessmentKey = `assessments.${assessmentId}`
      batch.update(studentRef, {
        [assessmentKey]: {
          assessmentId,
          userAssessmentId,
        }
      })

      // add the new userAssessment
      const userAssessmentRef = db.collection('userAssessments').doc(userAssessmentId)
      batch.set(userAssessmentRef, withAnswersByItem) 
      return batch.commit()
    })
    .then(() => {
      updateState(state => {
        return {processedStudents: state.processedStudents + 1}
      })
      return withAnswersByItem
    })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/createUserAssessment.js